var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSerachSelectBoxTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86255 8.71875H9.2603L9.04684 8.51292C9.79394 7.64385 10.2437 6.51559 10.2437 5.28822C10.2437 2.55142 8.0253 0.333008 5.28849 0.333008C2.55167 0.333008 0.333252 2.55142 0.333252 5.28822C0.333252 8.02502 2.55167 10.2434 5.28849 10.2434C6.51586 10.2434 7.64413 9.79365 8.5132 9.04656L8.71903 9.26001V9.86226L12.5308 13.6663L13.6666 12.5305L9.86255 8.71875ZM5.28849 8.71875C3.39025 8.71875 1.85794 7.18645 1.85794 5.28822C1.85794 3.38999 3.39025 1.85769 5.28849 1.85769C7.18672 1.85769 8.71903 3.38999 8.71903 5.28822C8.71903 7.18645 7.18672 8.71875 5.28849 8.71875Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerachSelectBoxTree);
export default __webpack_public_path__ + "static/media/serach-select-box-tree.0c7ab13d24f5ae5182aa0535569db28b.svg";
export { ForwardRef as ReactComponent };